/* RESPONSIBLE TEAM: team-omni */
import ApplicationAdapter from '../application';

export default class SlackIntegrationAdapter extends ApplicationAdapter {
  pathForType() {
    return 'slack/v2/integrations';
  }
}
